import React from 'react';
import type { AddOn } from '../AddOns';
import { ProductType } from '$/GraphQL/schema/schema';

export const AllAddOnsContext = React.createContext<{ addOns: AddOn[] }>({ addOns: [] });

export const useAddOn = (type: ProductType): AddOn => {
  const { addOns } = React.useContext(AllAddOnsContext);
  return React.useMemo(() => {
    const addOn = addOns.find((addOn) => addOn.type === type);
    if (!addOn) {
      throw new Error(`Missing priceTier in add-on with type: ${type}`);
    }
    return addOn;
  }, [addOns, type]);
};

export const useIsAddOnSubscribed = (type?: ProductType): boolean => {
  const { addOns } = React.useContext(AllAddOnsContext);
  if (!type) return true;
  const addOn = addOns.find((addOn) => addOn.type === type);
  return Boolean(addOn?.isSubscribed);
};
